@charset "UTF-8";

.headerRow {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	width: 100%;
}

.headerIconWrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;

	:global(.MuiTypography-root) {
		color: #212121;
		font-weight: 700;
		font-size: 1rem;
		line-height: 1.6;
	}
}

.descriptionRow {
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	max-width: 100%;
}

.name:global(.MuiTypography-root) {
	color: #212121;
	font-weight: 600;
	line-height: 1.4;
	font-size: 0.875rem;
	flex-shrink: 0;
	text-align: left;
}

.description:global(.MuiTypography-root),
.sentenceDropdownButton:global(.MuiButton-root) {
	color: #333333;
	font-size: 0.9375rem;
	line-height: 1.5;
	font-weight: 400;
}

.name:global(.MuiTypography-root),
.description:global(.MuiTypography-root) {
	&.wrap {
		flex-shrink: unset;
		max-width: unset;
		text-wrap: wrap;
		word-break: break-word;
		white-space: pre-line;
	}
}

.editButton:global(.MuiButton-root) {
	width: min-content;
	border-radius: 4px;
	box-sizing: border-box;
	min-width: unset;
	height: 24px;

	color: #42296e;
	font-weight: 500;
	font-size: 0.875rem;
	line-height: 1.6;

	& :global(.MuiButton-startIcon) {
		margin-right: 0.25rem;
		margin-bottom: 0.125rem;
	}

	&:hover {
		color: var(--primary-hover-font-color);
		background-color: var(--primary-hover-background-color);
		:global(.MuiButton-startIcon) {
			color: var(--primary-hover-font-color);
		}
	}

	:global(.MuiButton-startIcon) {
		color: #42296e;
	}
}

.editButtonIcon {
	border-radius: 8px;
	box-sizing: border-box;
	color: #42296e;
	flex-shrink: 0;
	width: 32px;
	height: 32px;
	padding: 4px;
}
.editButtonIcon svg {
	width: 100%;
	height: 100%;
}

.editLink:global(.MuiLink-root) {
	color: #42296e;
	font-size: 0.875rem;
	line-height: 1.6;
	font-weight: 400;

	&:hover {
		text-decoration: none;
	}
}

.liveSessionWarning:global(.MuiTypography-root) {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	font-weight: 400;
	font-size: 0.9375rem;
}

.confirmationContainer {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 0.625rem;
	padding: 0.9375rem;
	border-radius: 12px;
	width: 100%;
	box-sizing: border-box;
	border: 1px solid #e2e2e2;

	&.compact {
		gap: 0.25rem;
		padding: 0;
		border: none;

		& .title {
			color: #333333;
			font-size: 0.875rem;
			font-weight: 600;
			line-height: 1.6;
		}

		.description:global(.MuiTypography-root),
		.sentenceDropdownButton:global(.MuiButton-root) {
			color: #727272;
		}
	}
}

.thirdPartyPlatformIcon {
	& svg {
		flex-shrink: 0;
		max-height: 64px;
	}
}

.compactListContainer {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	width: 100%;
}

.restrictionsGrid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	width: 100%;
	row-gap: 0.5rem;
	column-gap: 1rem;
}

.compactContainerLayout {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
}

.compactTopRow {
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
	width: 100%;
	align-items: stretch;
}

.compactTopRow > .confirmationContainer {
	flex-grow: 1;
	flex-basis: calc(25% - 1rem);
	justify-content: flex-start;
	min-width: 0;
}

.gridItem {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	min-width: 0;
	width: 100%;
	max-height: 22px;

	& .gridIcon {
		flex-shrink: 0;
		height: 18px;
		width: 18px;
	}
}

.inlineKeywordGroup {
	display: inline-flex;
	align-items: center;
	vertical-align: baseline;
	max-width: 100%;
	min-width: 0;
}

.subOptionIcon {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
}

.dropdownListScrollContainer {
	display: flex;
	flex-direction: column;
	overflow-y: auto;
}

.dropdownListItemRow:global(.MuiListItem-root) {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.25rem 0;

	& :global(.MuiTypography-root) {
		color: #333333;
		font-size: 0.875rem;
		line-height: 1.6;
		font-weight: 400;
	}

	&.listStyle {
		display: inline-flex;
		align-items: flex-start;
		& :global(.MuiListItemText-root) > :global(.MuiTypography-root) {
			display: inline-flex;
			align-items: flex-start;

			&::before {
				content: "\2022";
				display: inline-block;
				padding-right: 0.5rem;
				color: #666666;
			}
		}
	}

	.subHeader:global(.MuiTypography-root) {
		padding-top: 0.5rem;
		border-top: 1px solid #e0e0e0;
		font-size: 0.75rem;
		color: #000;
	}
}

.listLink {
	width: 100%;
	max-width: 250px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	display: inline-block;
}

.viewMoreTextContainer {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.25rem;
	min-width: 0;
	width: 100%;
	flex-shrink: 0;
}

.sentenceDropdownButton:global(.MuiButton-root) {
	padding: 0;
}

.gridButtonWrapper {
	width: 100%;
}

.gridButton:global(.MuiButton-root) {
	width: 100%;
	justify-content: space-between;
}

@media (max-width: 768px) {
	.headerRow {
		flex-wrap: wrap;
	}
	.descriptionRow {
		flex-wrap: wrap;
	}

	.compactTopRow {
		flex-direction: column;
		gap: 1rem;
		align-items: flex-start;

		& > .confirmationContainer {
			border-radius: 12px;
			flex-basis: unset;
			flex-grow: unset;
		}
	}

	.confirmationContainer.compact {
		.headerRow {
			flex-direction: row;
			align-items: center;
			flex-wrap: wrap;
		}

		.descriptionRow {
			flex-wrap: unset;
		}
	}

	.restrictionsGrid {
		grid-template-columns: 1fr;
	}
}

.inlineKeywordGroup .referenceMaterialLink {
	cursor: pointer;
	color: #0b6f85;
	font-size: 15px;
	font-family: inherit;
	text-decoration: underline;

	&:hover {
		text-decoration: none;
	}

	& svg {
		width: 18px;
		height: 18px;
		vertical-align: text-top;
		margin-right: 0.1rem;
	}
}
